import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import Sign from '../Sign';
import {
  signAnimationsStop,
  signReset,
  signKeypadModeUpdate,
  signKeypadKeysShow,
  signKeypadClear,
  signKeypadKeyAdd,
  signKeypadKeyRemove,
  signRedirectStart,
  signRedirectStop,
  requestSign,
  sendNumber,
  updateDimensions
} from '../../actions';

const mapStateToProps = state => ({
  styles: state.styles,
  color: state.color,
  constants: state.constants,
  dimensions: state.dimensions,
  text: state.text,
  sign: state.sign
});

const mapDispatchToProps = dispatch => ({
  updateDimensions: dimensions => {
    dispatch(updateDimensions(dimensions));
  },
  reset: () => {
    dispatch(signReset());
  },
  stopAnimations: () => {
    dispatch(signAnimationsStop());
  },
  keypadModeUpdate: mode => {
    dispatch(signKeypadModeUpdate(mode));
  },
  keypadKeysShow: () => {
    dispatch(signKeypadKeysShow());
  },
  keypadClear: () => {
    dispatch(signKeypadClear());
  },
  keypadKeyAdd: key => {
    dispatch(signKeypadKeyAdd(key));
  },
  keypadKeyRemove: () => {
    dispatch(signKeypadKeyRemove());
  },
  requestSign: ({ id, redirect, duration }) => {
    dispatch(requestSign({ id, redirect, duration }));
  },
  sendNumber: (number, redirect) => {
    dispatch(sendNumber(number, redirect));
  },
  startRedirect: ({ redirect, duration }) => {
    dispatch(signRedirectStart({ redirect, duration }));
  },
  stopRedirect: () => {
    dispatch(signRedirectStop());
  },
  redirect: redirect => {
    dispatch(push(redirect));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(Sign);



// WEBPACK FOOTER //
// ./src/components/SignPage/index.js